/**
 * The only flagservice config the app provides: the connection URL and the
 * public client SDK key. Everything else — the providers, hooks, the bearer
 * token (read from `APP_TOKEN` in localStorage), background polling and caching —
 * comes from `@emilgroup/flags`. The SDK makes every HTTP call itself (it appends
 * the `/flagservice/v1` path); the app never calls the flagservice API directly.
 *
 * `baseUrl` follows the same per-environment convention as every other service:
 * it defaults to `PUBLIC_API_URL` — the API host that `config/paths.js` resolves
 * from `REACT_APP_CONFIG` (e.g. `https://apiv2-test.emil.de`) and that the axios
 * layer uses as its `baseURL`. The flagservice is served on that same host at
 * `/flagservice`, exactly like `/insuranceservice`, `/billingservice`, etc.
 * `REACT_APP_FLAGSERVICE_API_SERVER` overrides it per the `REACT_APP_<SERVICE>_API_SERVER`
 * pattern — set it to an empty string for local dev so the SDK calls
 * `/flagservice` same-origin and `src/setupProxy.js` proxies it to the local
 * flagservice.
 *
 * `clientSdkKey` (`REACT_APP_FLAGSERVICE_CLIENT_SDK_KEY`, baked in per build) is
 * the public `flg-client-…` key. The flagservice derives the environment from
 * it, so no environment key is needed, and the same key drives both the flag and
 * capability tracks.
 *
 * The background poll interval is not passed here: the SDK resolves it from
 * `REACT_APP_FLAGSERVICE_POLL_INTERVAL_MS` itself (the one env var the SDK reads).
 */
export const flagserviceBaseUrl: string =
  process.env.REACT_APP_FLAGSERVICE_API_SERVER ?? process.env.PUBLIC_API_URL ?? '';

export const flagserviceClientSdkKey: string | undefined =
  process.env.REACT_APP_FLAGSERVICE_CLIENT_SDK_KEY || undefined;
